/** The theme's colours as three.js colours. Every colour the renderer draws comes from here. */
import type { Theme } from '@ab/content-schema';
import * as THREE from 'three';

export type Palette = { readonly [K in keyof Theme['palette']]: THREE.Color };

export const paletteOf = (theme: Theme): Palette => {
  const p = theme.palette;
  const c = (hex: string): THREE.Color => new THREE.Color(hex);
  return {
    background: c(p.background),
    floor: c(p.floor),
    wall: c(p.wall),
    fog: c(p.fog),
    party: c(p.party),
    enemy: c(p.enemy),
    boss: c(p.boss),
    spring: c(p.spring),
    exit: c(p.exit),
    trim: c(p.trim),
    timber: c(p.timber),
    iron: c(p.iron),
    hit: c(p.hit),
    heal: c(p.heal),
    cast: c(p.cast),
    status: c(p.status),
    rail: c(p.rail),
    sleeper: c(p.sleeper),
    foliage: c(p.foliage),
    ore: c(p.ore),
    rope: c(p.rope),
    crystal: c(p.crystal),
  };
};

/** A copy of `base` scaled by `factor` (shading within the palette, never a new hue). */
export const shaded = (base: THREE.Color, factor: number): THREE.Color => base.clone().multiplyScalar(factor);
